import React from "react";

const VideoPage = () => {
  return (
    <div style={styles.page}>
      <div style={styles.wrapper}>
        <div style={styles.videoContainer}>
          <iframe
            style={styles.iframe}
            src="https://www.youtube.com/watch?v=WHCZI47A-H8"
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    padding: "2rem 1rem",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#f8fafc",
  },
  wrapper: {
    width: "100%",
    maxWidth: "500px",
    textAlign: "center",
  },
  title: {
    marginBottom: "1rem",
    fontSize: "1.8rem",
  },
  videoContainer: {
    position: "relative",
    width: "100%",
    paddingBottom: "56.25%", // 16:9 ratio
    borderRadius: "10px",
    overflow: "hidden",
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: 0,
  },
};

export default VideoPage;
